export default __webpack_public_path__ + "static/media/sandal15.3eb51d6b.jpeg";